import { Text, View } from "@react-pdf/renderer";
import { PDFTableColumn } from "components/PDF/Table";
import { CategoriaFinanceiraItem } from "features/condominio/hooks/useListFinancialCategory";
import { useMemo } from "react";
import colors from "core/resources/theme/colors";

function useExportarPDFPlanoContasColumns(): PDFTableColumn<CategoriaFinanceiraItem>[] {
  return useMemo(() => {
    return [
      {
        title: "Categoria",
        flexGrow: 1.5,
        render: (item: CategoriaFinanceiraItem) => (
          <View>
            <Text
              style={{ paddingLeft: 4 * item.breadcrumb.length - 1 }}
            >{`${item.breadcrumb} ${item.nome}`}</Text>
          </View>
        ),
      },
      {
        title: "Centro de Custo",
        flexGrow: 1,
        render: (item: CategoriaFinanceiraItem) => (
          <View>
            <Text
              style={{
                opacity: !item.centroDeCusto?.nome ? 0.7 : 1,
              }}
            >
              {item.centroDeCusto?.nome || "--"}
            </Text>
          </View>
        ),
      },
      {
        title: "Código de Integração",
        flexGrow: 1,
        render: (item: CategoriaFinanceiraItem) => (
          <View>
            <Text
              style={{
                opacity: !item.codigoIntegracao ? 0.7 : 1,
              }}
            >
              {item.codigoIntegracao || "--"}
            </Text>
          </View>
        ),
      },
      {
        title: "Status",
        flexGrow: 0.7,
        render: (item: CategoriaFinanceiraItem) => (
          <View>
            <Text
              style={{ color: item.ativo ? colors.green500 : colors.red500 }}
            >
              {item.ativo ? "Ativo" : "Inativo"}
            </Text>
          </View>
        ),
      },
    ] as PDFTableColumn<CategoriaFinanceiraItem>[];
  }, []);
}

export default useExportarPDFPlanoContasColumns;
